import { Form, Radio } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import PatientAppointmentForm from '../AdminAppointment/PatientAppointmentForm'
import MaintenanceAppointmentForm from '../AdminAppointment/MaintenanceAppointmentForm'
import WorkAppointmentForm from '../AdminAppointment/WorkAppointmentForm'
import CleaningAppointmentForm from '../AdminAppointment/CleaningAppointmentForm'

export default function AppointmentCreationForm ({ form, onFinish, rangeDisable }) {
  const [appointmentType, setAppointmentType] = useState(form.getFieldValue('type'))
  if (form.getFieldValue('type') !== appointmentType) {
    setAppointmentType(form.getFieldValue('type'))
  }
  const forms = {
    PatientAppointment: PatientAppointmentForm,
    MaintenanceAppointment: MaintenanceAppointmentForm,
    WorkAppointment: WorkAppointmentForm,
    CleaningAppointment: CleaningAppointmentForm
  }
  const SubForm = forms[appointmentType]

  const onDateChange = (value) => {
    if (value[0].isSame(value[1])) {
      form.setFieldsValue({ range: [value[0], value[1].add(1, 'hour')] })
    }
    form.setFieldsValue({ appointment_date: value[0] })
  }

  return (
    <Form
      id="AppointmentFormAdmin"
      size='small'
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
    >

      <Form.Item name="type"
        rules={[{ required: true, message: t('rules.required') }]}
      >
        <Radio.Group onChange={({ target: { value } }) => setAppointmentType(value)}>
          <Radio value='PatientAppointment'>{t('Admin.Appointment.type.PatientAppointment')}</Radio>
          <Radio value='MaintenanceAppointment'>{t('Admin.Appointment.type.MaintenanceAppointment')}</Radio>
          <Radio value='WorkAppointment'>{t('Admin.Appointment.type.WorkAppointment')}</Radio>
          <Radio value='CleaningAppointment'>{t('Admin.Appointment.type.CleaningAppointment')}</Radio>
        </Radio.Group>
      </Form.Item>
      <SubForm form={form} onDateChange={onDateChange} rangeDisable={rangeDisable} />
    </Form>
  )
}
